import Vue from 'vue'
import Vuex from 'vuex'

import vuejsStorage from 'vuejs-storage'

import { isEmpty } from 'lodash'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'mmpAuth'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        saveId: '',
        autoLogin: false,
        session: {},
        token: {},
        beforeRoute: {},
        isNrwMobile: false,
        pushKeyId: ''
      },
      getters: {
        isAutoLogin: state => {
          return state.autoLogin
        },
        isSaveId: state => {
          return !isEmpty(state.saveId)
        },
        getBeforeRoute: (state) => (defaultRoute) => {
          return isEmpty(state.beforeRoute) ? defaultRoute : state.beforeRoute
        },
        isNrwMobile: state => {
          return state.isNrwMobile
        },
        pushKeyId: state => {
          return state.pushKeyId
        },
        getToken: state => {
          return state.token
        }
      },
      mutations: {
        // 토큰 저장
        SET_AUTO_LOGIN (state, {session}) {
          state.autoLogin = true
          Vue.set(state, 'session', session)
          // if (!isEmpty(state.session)) {
          //   state.autoLogin = true
          // } else {
          //   state.autoLogin = false
          // }
        },
        CLEAR_AUTO_LOGIN (state) {
          console.log('CLEAR_AUTO_LOGIN' )
          Vue.set(state, 'session', {})
          // Vue.set(state, 'token', {}) // 신규탭 오픈시 자동 로그인을 위해
          state.autoLogin = false
        },
        SET_SAVE_ID (state, userId) {
          if (isEmpty(userId)) {
            state.saveId = ''
          } else {
            state.saveId = userId
          }
        },
        SET_BEFORE_ROUTE (state, next) {
          Vue.set(state, 'beforeRoute', next)
        },
        CLEAR_BEFORE_ROUTE (state) {
          Vue.set(state, 'beforeRoute', {})
        },
        SET_NRW_INFO (state, isNrwMobile) {
          Vue.set(state, 'isNrwMobile', isNrwMobile )

          let pushKeyId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0
            let v = c === 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16)
          })

          Vue.set(state, 'pushKeyId', pushKeyId)
        },
        // 토큰 저장
        SET_TOKEN_INFO (state, {token}) {
          Vue.set(state, 'token', token)
        },
        // 토큰 클리어
        CLEAR_TOKEN_INFO (state) {
          Vue.set(state, 'token', {})
        }
      },
      plugins: [
        vuejsStorage({
          keys: ['saveId'],
          namespace: 'mmp-app-mmpAuth-saveId',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['autoLogin'],
          namespace: 'mmp-app-mmpAuth-autoLogin',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['token'],
          namespace: 'mmp-app-mmpAuth-token',
          driver: vuejsStorage.drivers.localStorage
        }),
        vuejsStorage({
          keys: ['session'],
          namespace: 'mmp-app-mmpAuth-session',
          driver: vuejsStorage.drivers.localStorage
        })
      ]
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/mmpAuth.js